import React from 'react';
import { ClassAssembly9E2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly9E2026/>;
  };
  
  export default ClassAssemblyPage;